import { panelRangeSharedProps as e } from "./index935.js";
import { buildProps as r } from "./index601.js";
const p = r({
  ...e
}), n = [
  "pick",
  "set-picker-option",
  "calendar-change"
];
export {
  n as panelYearRangeEmits,
  p as panelYearRangeProps
};
